<div *ngIf="isMobile" class="mobile-container d-flex d-sm-none flex-column vh-100">
  <div class="mobile-title-bar flex-shrink-0 d-flex align-items-center justify-content-between px-2 py-2">
    <div class="d-flex align-items-center">
      <div class="title-block">
        <h1>Global Water Monitor</h1>
      </div>
    </div>

    <ul ngbNav #nav="ngbNav" [(activeId)]="mobileViewActiveTab" (navChange)="onMobileTabChange($event)" class="nav-tabs mobile-nav-tabs mb-0">
      <li [ngbNavItem]="1">
        <a ngbNavLink><i class="fa fa-map"></i></a>
        <ng-template ngbNavContent>
          <ng-container *ngTemplateOutlet="mainMap"></ng-container>
        </ng-template>
      </li>
      <li [ngbNavItem]="2" [destroyOnHide]="false">
        <a ngbNavLink><i class="fa fa-bar-chart"></i></a>
        <ng-template ngbNavContent>
          <div class="mobile-scrollable-content">
            <ng-container *ngTemplateOutlet="mainChart"></ng-container>
          </div>
        </ng-template>
      </li>
      <li [ngbNavItem]="3" [destroyOnHide]="false">
        <a ngbNavLink><i class="fa fa-cogs"></i></a>
        <ng-template ngbNavContent>
          <div class="mobile-scrollable-content">
            <div>
              <ng-container *ngTemplateOutlet="mainControls"></ng-container>
            </div>
            <div>
              <p><strong>Map settings</strong></p>
              <ng-container *ngTemplateOutlet="advancedControls"></ng-container>
            </div>
          </div>
        </ng-template>        
      </li>
    </ul>
  </div>
  <div [ngbNavOutlet]="nav" class="flex-grow-1 mobile-content-area"></div>
</div>

<div *ngIf="!isMobile" class="row d-none d-sm-flex">
  <div class="options-panel col-xs-12 col-sm-4 col-md-3 col-lg-3">
    <div class="title-block">
      <h1>Global Water Monitor</h1>
    </div>
    <div class="card">
      <div class="card-body">
        <ng-container *ngTemplateOutlet="mainControls"></ng-container>
      </div>
    </div>
    <div *ngIf="mapConfig?.showAdvanced" class="card">
      <div class="card-body">
        <ng-container *ngTemplateOutlet="advancedControls"></ng-container>
      </div>
    </div>
    <div *ngIf="mapConfig?.showInlineChart" class="card">
      <div class="card-body">
        <ng-container *ngTemplateOutlet="mainChart"></ng-container>
      </div>
    </div>
    <div *ngIf="!mapConfig?.showInlineChart&&!mapConfig?.showAdvanced" class="card">
      <div class="card-body">
        <div class="row">
          <strong>Time series</strong>
          <div class="chart-placeholder">
            Click <i class="fa fa-compress"></i> on the chart to move it back here
          </div>
        </div>
      </div>
    </div>
    <div class="card" *ngIf="mapConfig.spatialDownloads">
      <div class="card-body">
        <spatial-download-panel [currentBounds]="bounds" [downloadServices]="downloadServices"
          [selectedFeature]="selectedFeature" [wmsURL]="dataOverlay?.wms?.url"
          [wmsParameters]="dataOverlay?.wms?.params"
          [title]="dataOverlay.selection.flattened?.variantLabel||dataOverlay.selection.flattened?.label"
          [subtitle]="legendExplanation" [units]="legendUnits"
          [parameters]="{overlay:dataOverlay,boundaries:boundaries,featureID:selectedFeatureID,featureLabel:selectedFeatureLabel}"
          [featureLayer]="boundaries.layer"
          [vectorLayer]="boundaries.layer?.tiles||boundaries.layer?.filename||boundaries.layer?.source"
          (boundsChanged)="downloadBoundsChanged($event)"></spatial-download-panel>
      </div>
    </div>
    <div class="card" *ngIf="mapConfig.debug">
      <div class="card-body">
        <button class="btn btn-primary" (click)="mapConfig.screenshotMode=!mapConfig.screenshotMode">Toggle screenshot
          mode</button>
        <button class="btn btn-primary" (click)="copyViewSettings()">Copy View Settings</button>
        <button class="btn btn-warning" (click)="forceRefresh()">Force Refresh</button>
        <button class="btn btn-primary" (click)="mapConfig.showDebugOverMap=!mapConfig.showDebugOverMap">Toggle
          expression</button>
        <p><strong>URL</strong>{{fragment}}</p>
        <p><strong>Map Config</strong>{{mapConfig | json }}</p>
        <p><strong>Layers</strong>({{map?.layerCount}})</p>
        <ul>
          <li *ngFor="let l of map?.layerNames">{{l}}</li>
        </ul>

        <p><strong>Terrakio parameters</strong>{{dataOverlay?.wms?.params | json}}</p>
      </div>
    </div>
  </div>

  <div class="col-xs-12 col-sm-8 col-md-9 col-lg-9">
    <ng-container *ngTemplateOutlet="mainMap"></ng-container>
  </div>
</div>

<one-time-splash #splash application="global-water" klass="about" label="">
  <app-about (tourStarted)="tourStartedFromAbout($event)"></app-about>
</one-time-splash>

<ng-template #mainControls>
  <div class="row">
    <p><strong>What</strong></p>
    <app-map-layer-selection (selectionChanged)="layerSelectionChanged($event)"
      (displaySettingsChange)="mapSettingChanged($event)" [choropleth]="mapConfig.choropleth"
      [choroplethAvailable]="!!dataOverlay?.selection?.flattened?.zonal"
      [layerSelection]="dataOverlay.selection"></app-map-layer-selection>
  </div>
  <div class="row">
    <p><strong>When</strong></p>
    <app-time-period-selection [legacy]="false" [overlaySelection]="dataOverlay.selection"
      [timePeriod]="dataOverlay.timePeriod"
      (timePeriodChanged)="timePeriodChanged($event)"></app-time-period-selection>
  </div>
  <div *ngIf="!isMobile" class="row">
    <div class="col-12">
      <span class="float-end">
        <button class="btn btn-primary" (click)="toggleAdvancedMapSettings()"
          ngbTooltip="Toggle advanced map settings"><i class="fa fa-cog"></i></button>
      </span>
    </div>
  </div>
</ng-template>

<ng-template #advancedControls>
  <div class="row">
    <app-display-settings [opacity]="opacity"
                          [basemap]="basemap"
                          [vectorLayer]="boundaries.layer"
                          [showLegend]="mapConfig.showLegend"
                          [showScale]="mapConfig.showScale"
                          (displaySettingsChange)="mapSettingChanged($event)">
    </app-display-settings>
  </div>
</ng-template>

<ng-template #mainChart>
  <div class="row">
    <strong>Time series</strong>
    <app-chart-panel [validModes]="mapConfig.validMapSelectionModes"
                      [overlaySelection]="dataOverlay.selection"
                      [timePeriod]="dataOverlay.timePeriod"
                      [vectorLayer]="boundaries.layer"
                      [selectedFeature]="selectedFeature"
                      [allowExpand]="!isMobile"
                      (loadingStarted)="chartLoadingStarted()"
                      (loadingFinished)="chartLoadingFinished()"
                      (chartCleared)="clearSelection()"
                      [selectionMode]="polygonMode"
                      (selectionModeChange)="polygonModeChanged($event)"
                      (sizeToggled)="chartExpanded()"
                      [chartMode]="mapConfig.chartMode"
                      (chartModeChange)="chartModeChanged($event)"></app-chart-panel>

  </div>
</ng-template>

<ng-template #mainMap>
  <leaflet-map #theMap class="main-map" [baseMap]="basemap" [bounds]="bounds" [minZoom]="1" [maxZoom]="16"
    [zoomAnimation]="true" [zoomControl]="false" [doubleClickZoom]="false" [pointSelection]="true"
    (pointSelected)="pointSelected($event)" (boundsChanged)="mapBoundsChanged($event)"
    (pointDoubleClicked)="mapDoubleClick($event)" [scaleBar]="mapConfig.showScale">

    <!-- <wms-layer *ngIf="!mapConfig.choropleth" id="grid-layer" [url]="dataOverlay.wms.url"
      [params]="dataOverlay.wms.params" [zIndex]="-30" (loading)="wmsLoading()" (loaded)="wmsLoaded()"></wms-layer> -->

    <tile-layer *ngIf="!dataOverlay.points.displayFeatures&&!mapConfig.choropleth&&dataOverlay.wms.tileID" id="grid-layer" [url]="dataOverlay.wms.tileURL"
      [zIndex]="-30" [opacity]="opacity*0.01" (loading)="wmsLoading()" (loaded)="wmsLoaded()"></tile-layer>

    <draw *ngIf="mapConfig.enableDrawing" (featureClosed)="polygonFeatureSelected($event)">
    </draw>

    <geojson-layer *ngIf="customDownloadBounds" id="download-bounds-visual"
      [style]="{weight:1,fillOpacity:0.5,fillcolor:'#000000'}" [features]="customDownloadBounds">
    </geojson-layer>

    <geojson-layer *ngIf="dataOverlay.points.displayFeatures&&!mapConfig.choropleth" id="point-features"
      [features]="dataOverlay.points.displayFeatures" [pointMode]="pointMode.circle"
      [tooltipFormat]="'{{chartLabel}} {{value}} {{units}}'" [style]="dataOverlay.points.styles"
      [selectedFeature]="selectedFeature" (featureSelected)="pointFeatureSelected($event)" [zIndex]="400">
    </geojson-layer>

    <geojson-layer *ngIf="mapConfig.latLngSelection&&polygonFeaturesForSelectedPoint" id="selected-lat-lng-square"
      [features]="polygonFeaturesForSelectedPoint" [style]="{weight:1,fillOpacity:1,color:'#00000099'}">
    </geojson-layer>

    <geojson-layer *ngIf="mapConfig.showBoundaries&&mapConfig.allowPolygonSelection&&boundaries.layer?.source"
      id="boundary-features-selectable" [url]="boundaries.layer.source"
      (featureSelected)="polygonFeatureSelected($event)">
    </geojson-layer>

    <geojson-layer *ngIf="mapConfig.showBoundaries&&!mapConfig.allowPolygonSelection&&boundaries.layer?.source"
      id="boundary-features-not-selectable" [url]="boundaries.layer.source">
    </geojson-layer>

    <vector-tile-layer *ngIf="mapConfig.showBoundaries&&baseBoundaries.layer?.tileLayers"
      id="boundary-vector-tiles-not-selectable-base" [url]="baseBoundaries.layer.tiles"
      [styles]="baseBoundaries.styles" [sublayers]="baseBoundaries.layer.tileLayers"
      [minNativeZoom]="baseBoundaries.layer.availableZooms[0]"
      [maxNativeZoom]="baseBoundaries.layer.availableZooms[1]" [zIndex]="110"></vector-tile-layer>

    <vector-tile-layer *ngIf="mapConfig.showBoundaries&&mapConfig.allowPolygonSelection&&boundaries.layer?.tileLayers"
      id="boundary-vector-tiles-selectable" [url]="boundaries.layer.tiles" [styles]="boundaries.styles"
      [sublayers]="boundaries.layer.tileLayers" [minNativeZoom]="boundaries.layer.availableZooms[0]"
      [maxNativeZoom]="boundaries.layer.availableZooms[1]" [highlightedFeatureStyles]="{weight:10,color:'yellow'}"
      (loading)="vectorTileLoading($event)" (featureSelected)="polygonFeatureSelected($event)"></vector-tile-layer>

    <vector-tile-layer
      *ngIf="mapConfig.showBoundaries&&!mapConfig.allowPolygonSelection&&boundaries.layer?.tileLayers"
      id="boundary-vector-tiles-not-selectable" [url]="boundaries.layer.tiles" [styles]="boundaries.styles"
      [sublayers]="boundaries.layer.tileLayers" [minNativeZoom]="boundaries.layer.availableZooms[0]"
      [maxNativeZoom]="boundaries.layer.availableZooms[1]" (loading)="vectorTileLoading($event)"></vector-tile-layer>

    <map-control [position]="'TOP_RIGHT'">
      <app-map-buttons [minZoom]="0" [maxZoom]="16"
                        (optionsChanged)="displayOptionsChanged($event)"
                        [helpModal]="splash"
                        [feedbackAddress]="feedbackAddress"
                        [orientation]="'horizontal'"
                        [hintPlacement]="'bottom'"
                        (tourStarted)="tourStartedFromButtonBar($event)"
                        (shareView)="copySharingLinkToClipboard()"
                        (downloadMap)="showMapDownload()">
      </app-map-buttons>
    </map-control>

    <map-control [position]="'TOP_LEFT'">
      <div *ngIf="tour">
        <tour [tour]="tour" [map]="theMap" (closed)="tourClosed()" [viewChangeCompleted]="viewChangeCount"
          (viewChanged)="applyTourView($event)"></tour>
      </div>
      <div *ngIf="isProcessing" class="loading-indicator">
        <span>Loading</span>
        <i class="fa fa-spinner fa-pulse fa-2x fa-fw"></i>
      </div>
    </map-control>
    <map-control [position]="'BOTTOM_RIGHT'">
      <div *ngIf="showWindows&&dataOverlay.selection.layer&&mapConfig.showLegend" class="map-controls legend"
        [class.screenshot]="mapConfig.screenshotMode">
        <legend [legend]="legend"
          [title]="dataOverlay.selection.flattened?.legendLabel||dataOverlay.selection.flattened?.variantLabel||dataOverlay.selection.flattened?.label"
          [description]="legendExplanation" [mapUnits]="legendTitleUnits"
          [helpText]="dataOverlay.selection.layer.help" [tooltipPlacement]="'top'">
        </legend>
        <br />
        <span *ngIf="!mapConfig.screenshotMode">
          <span *ngIf="dataOverlay.selection.layer.attribution&&dataOverlay.selection.layer.attributionURL">
            (source: <a class="legend-attribution-link" [href]="dataOverlay.selection.layer.attributionURL"
              target="_blank">{{dataOverlay.selection.layer.attribution}}</a>)
          </span>
          <span *ngIf="dataOverlay.selection.layer.attribution&&!dataOverlay.selection.layer.attributionURL">
            (source: {{dataOverlay.selection.layer.attribution}})
          </span>
        </span>
      </div>
    </map-control>

    <map-control *ngIf="mapConfig.showLargeChart" [position]="'BOTTOM_LEFT'">
      <div class="map-chart-control">
        <app-chart-panel [validModes]="mapConfig.validMapSelectionModes"
                          [overlaySelection]="dataOverlay.selection"
                          [timePeriod]="dataOverlay.timePeriod"
                          [vectorLayer]="boundaries.layer"
                          [selectedFeature]="selectedFeature"
                          (loadingStarted)="chartLoadingStarted()"
                          (loadingFinished)="chartLoadingFinished()"
                          (chartCleared)="clearSelection()"
                          (sizeToggled)="chartCollapsed()"
                          [selectionMode]="polygonMode"
                          (selectionModeChange)="polygonModeChanged($event)"
                          [chartMode]="mapConfig.chartMode"
                          (chartModeChange)="chartModeChanged($event)"
                          [expanded]="true"></app-chart-panel>
      </div>
    </map-control>

    <map-control *ngIf="mapConfig.showDebugOverMap&&dataOverlay?.wms?.params" [position]="'BOTTOM_LEFT'">
      <div class="debug-control">
        <pre>{{dataOverlay?.wms?.params?.expression}}</pre>
        <div>
          <button class="btn btn-secondary" (click)="copyWMSExpression()">
            <i class="fa fa-copy"></i>
          </button>
        </div>
      </div>
    </map-control>
  </leaflet-map>
</ng-template>